// extracted by mini-css-extract-plugin
module.exports = {"loading":"Select_loading__nl2AT","ellipsis":"Select_ellipsis__buljy","container":"Select_container__M4r6t","main":"Select_main__T5w7n"};